<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs >
        <a-tab-pane key="1" tab="包邮卡列表">
          <cardList></cardList>
        </a-tab-pane>
        <a-tab-pane key="2" tab="包邮卡使用统计">
          <cardUsedList></cardUsedList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import cardList from './components/cardList';
import cardUsedList from './components/cardUsedList';
export default {
  components: {cardList,cardUsedList },
  setup(props) {
    const state = reactive({

    });
    const $router = inject('$router')
    const $Modal = inject('$Modal')
    const momentTime = inject('momentTime')
    
    onMounted(() => {
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>